export default __webpack_public_path__ + "static/media/logo.bbe2a6ea.svg";